import { Divider } from "antd";
import moment from "moment";

export default function ReviewComment(props: { comment: any, scope: string, reviewReplyUpdateTime: any, isReply: boolean, isObsolete: boolean, googleState?: any }) {  

  return (
    <div className='comment-review' style={{color: props.isReply ? props.isObsolete ? 'orange' : 'lightseagreen' : 'slategrey'}}>
      {props.googleState && <div style={{display:'flex', justifyContent:'right'}}><i>{props.googleState}</i></div>}
      { 
        props.comment?.originalText ? props.comment?.originalText : props.comment?.text
      }
      <i style={{display:'flex', justifyContent:'right'}}>
        <small style={{ borderRadius: '20px', marginTop:'10px' }}>
          <div>{moment(props.reviewReplyUpdateTime).format('ll')}</div>
          {props.scope && <>{SCOPE_LABELS[props.scope]}</>}
        </small>
      </i>
      {
        props.comment?.translatedText &&
          <div>
            <Divider style={{margin: '10px 0px'}}/>
            <small style={{color:'#bbc'}}>            
              <i><b>Translated By Google:</b> {props.comment?.translatedText}</i>
            </small>
          </div>
      }
    </div>
  );
}

export const SCOPE_LABELS: {[key:string] : string } = {
  SYNC: 'Sincronizado',
  MANUAL: 'Respuesta manual',
  AUTOMATED: 'Respuesta automática',   
}
